import React from 'react';
import { useIntl } from 'react-intl';

import { PersonIcon } from './icons';
import { FilterButton } from './styles';

interface CoworkerSearchButtonProps {
  onClick: VoidFunction;
  /** A coworker group is focused on the map — drawn active like the filter button with filters on. */
  isActive?: boolean;
}

/**
 * The find-a-coworker entry point next to the filters (§C2) — the same outlined control as the
 * filter button so the row reads as one set. Rendered only while the building's configuration lets
 * coworkers be shown at all (`useCoworkerVisibility().isCoworkerLayerEnabled`); that gate is the
 * caller's, so this stays a plain control.
 */
export const CoworkerSearchButton = ({ onClick, isActive = false }: CoworkerSearchButtonProps): JSX.Element => {
  const intl = useIntl();

  return (
    <FilterButton
      type="button"
      data-testid="coworker-search-button"
      aria-label={intl.formatMessage({ id: 'findCoworker' })}
      aria-haspopup="dialog"
      aria-pressed={isActive}
      isActive={isActive}
      onClick={onClick}
    >
      <PersonIcon />
    </FilterButton>
  );
};
